export default __webpack_public_path__ + "static/media/Monger-HUD-Pop-Up (Informational).9fb718f1.jpg";